import angular from 'angular';
import customerIntegrationInputComponent from './customerIntegrationInput.component';

let customerIntegrationInputModule = angular.module('customerIntegrationInput', []).directive('customerIntegrationInput', customerIntegrationInputComponent);

export default customerIntegrationInputModule;



// WEBPACK FOOTER //
// ./app/components/customerIntegrationInput/customerIntegrationInput.js